import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import PassImg from "../../images/Pass-Screely.png";
import CovidApp from "../../images/CovidApp-Screely.png";
import Multilink from "../../images/multilink-screely.png";
import FindGHImg from "../../images/Find-GH-Screely.png";
import MediaFlix from "../../images/Media-Screely.png";
import CovidWeb from "../../images/TrackCorona-Screely.png";
import VehicleRegImg from "../../images/Vehicle-Reg-Screely.png";
import ChatApp from "../../images/Chat App.png";
import pepperFry from "../../images/pepperfryApp.png";
import todoApp from "../../images/todoAppDesign.png";
import AmongUs from "../../images/AmongUs_Thumbnail.png";
import CODM from "../../images/CODM_THUMBNAIL_5.png";
import Valorant1 from "../../images/Valorant_4.png";
import Valorant2 from "../../images/VALORANT_THUMBNAIL.png";
import { HashLink as Link } from "react-router-hash-link";
export default function All() {
  return (
    <AnimatePresence>
      <div className="row">
        <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
          <Link to="/multiLink#projectDetails">
            <motion.img
              whileHover={{
                scale: 1.1,
                transition: { duration: 0.4, ease: [0.6, 0.01, -0.05, 0.9] },
              }}
              src={Multilink}
              style={{
                width: "90%",
                borderRadius: "4px",
                margin: "1rem",
                cursor: "pointer",
              }}
              alt=""
            />

            <h6 className="text-center proj--name">Multilink Web App</h6>
          </Link>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
          <Link to="/FindGH#projectDetails">
            <motion.img
              whileHover={{
                scale: 1.1,
                transition: { duration: 0.4, ease: [0.6, 0.01, -0.05, 0.9] },
              }}
              src={FindGHImg}
              style={{
                width: "90%",
                borderRadius: "4px",
                margin: "1rem",
                cursor: "pointer",
              }}
              alt=""
            />

            <h6 className="text-center proj--name">Find GitHub Web App</h6>
          </Link>
        </div>
        <div
          data-aos-delay="1.6"
          className="col-lg-4 col-md-6 col-sm-6 col-xs-12"
        >
          <Link to="/MediaFlix#projectDetails">
            <motion.img
              whileHover={{
                scale: 1.1,
                transition: { duration: 0.4, ease: [0.6, 0.01, -0.05, 0.9] },
              }}
              src={MediaFlix}
              style={{
                width: "90%",
                borderRadius: "4px",
                margin: "1rem",
                cursor: "pointer",
              }}
              alt=""
            />{" "}
            <h6 className="text-center proj--name"> MediaFlix Web App</h6>
          </Link>
        </div>
        <div
          data-aos-delay="1.8"
          className="col-lg-4 col-md-6 col-sm-6 col-xs-12"
        >
          <Link to="/passGen#projectDetails">
            <motion.img
              whileHover={{
                scale: 1.1,
                transition: { duration: 0.4, ease: [0.6, 0.01, -0.05, 0.9] },
              }}
              src={PassImg}
              style={{
                width: "90%",
                borderRadius: "4px",
                margin: "1rem",
                cursor: "pointer",
              }}
              alt=""
            />{" "}
            <h6 className="text-center proj--name">Password Generator App</h6>
          </Link>
        </div>
        <div
          data-aos-delay="2"
          className="col-lg-4 col-md-6 col-sm-6 col-xs-12"
        >
          <Link to="/CovidApp#projectDetails">
            <motion.img
              whileHover={{
                scale: 1.1,
                transition: { duration: 0.4, ease: [0.6, 0.01, -0.05, 0.9] },
              }}
              src={CovidApp}
              style={{
                width: "90%",
                borderRadius: "4px",
                margin: "1rem",
                cursor: "pointer",
              }}
              alt=""
            />{" "}
            <h6 className="text-center proj--name">
              Covid-19 Cases Tracker App
            </h6>
          </Link>
        </div>
        <div
          data-aos-delay="2.3"
          className="col-lg-4 col-md-6 col-sm-6 col-xs-12"
        >
          <Link to="/CovidWeb#projectDetails">
            <motion.img
              whileHover={{
                scale: 1.1,
                transition: { duration: 0.4, ease: [0.6, 0.01, -0.05, 0.9] },
              }}
              src={CovidWeb}
              style={{
                width: "90%",
                borderRadius: "4px",
                margin: "1rem",
                cursor: "pointer",
              }}
              alt=""
            />{" "}
            <h6 className="text-center proj--name">
              Covid-19 Cases Tracker Web App
            </h6>
          </Link>
        </div>
        <div
          data-aos-delay="2.6"
          className="col-lg-4 col-md-6 col-sm-6 col-xs-12"
        >
          <Link to="/VehicleRegInfo#projectDetails">
            <motion.img
              whileHover={{
                scale: 1.1,
                transition: { duration: 0.4, ease: [0.6, 0.01, -0.05, 0.9] },
              }}
              src={VehicleRegImg}
              style={{
                width: "90%",
                borderRadius: "4px",
                margin: "1rem",
                cursor: "pointer",
              }}
              alt=""
            />{" "}
            <h6 className="text-center proj--name">
              Vehicle Registration Information
            </h6>
          </Link>
        </div>
        <div
          data-aos-delay="2.8"
          className="col-lg-4 col-md-6 col-sm-6 col-xs-12"
        >
          <Link to="/ChatApp#projectDetails">
            <motion.img
              whileHover={{
                scale: 1.1,
                transition: { duration: 0.4, ease: [0.6, 0.01, -0.05, 0.9] },
              }}
              src={ChatApp}
              style={{
                width: "90%",
                borderRadius: "4px",
                margin: "1rem",
                cursor: "pointer",
              }}
              alt=""
            />{" "}
            <h6 className="text-center proj--name">
              Chat App Design In Adobe XD
            </h6>
          </Link>
        </div>
        <div
          data-aos-delay="3"
          className="col-lg-4 col-md-6 col-sm-6 col-xs-12"
        >
          <Link to="/pepperFry#projectDetails">
            <motion.img
              whileHover={{
                scale: 1.1,
                transition: { duration: 0.4, ease: [0.6, 0.01, -0.05, 0.9] },
              }}
              src={pepperFry}
              style={{
                width: "90%",
                borderRadius: "4px",
                margin: "1rem",
                cursor: "pointer",
              }}
              alt=""
            />{" "}
            <h6 className="text-center proj--name">
              Pepperfry App Design In Adobe XD
            </h6>
          </Link>
        </div>
        <div
          data-aos-delay="3.3"
          className="col-lg-4 col-md-6 col-sm-6 col-xs-12"
        >
          <Link to="/todoApp#projectDetails">
            <motion.img
              whileHover={{
                scale: 1.1,
                transition: { duration: 0.4, ease: [0.6, 0.01, -0.05, 0.9] },
              }}
              src={todoApp}
              style={{
                width: "90%",
                borderRadius: "4px",
                margin: "1rem",
                cursor: "pointer",
              }}
              alt=""
            />{" "}
            <h6 className="text-center proj--name">
              Todo App Design In Adobe XD
            </h6>
          </Link>
        </div>
        <div
          data-aos-delay="3.6"
          className="col-lg-4 col-md-6 col-sm-6 col-xs-12"
        >
          <Link to="/AmongUs#projectDetails">
            <motion.img
              whileHover={{
                scale: 1.1,
                transition: { duration: 0.4, ease: [0.6, 0.01, -0.05, 0.9] },
              }}
              src={AmongUs}
              style={{
                width: "90%",
                borderRadius: "4px",
                margin: "1rem",
                cursor: "pointer",
              }}
              alt=""
            />{" "}
            <h6 className="text-center proj--name">Amongus Thumbnail</h6>
          </Link>
        </div>
        <div
          data-aos-delay="3.8"
          className="col-lg-4 col-md-6 col-sm-6 col-xs-12"
        >
          <Link to="/CODM#projectDetails">
            <motion.img
              whileHover={{
                scale: 1.1,
                transition: { duration: 0.4, ease: [0.6, 0.01, -0.05, 0.9] },
              }}
              src={CODM}
              style={{
                width: "90%",
                borderRadius: "4px",
                margin: "1rem",
                cursor: "pointer",
              }}
              alt=""
            />{" "}
            <h6 className="text-center proj--name">
              Call Of Duty Mobile Highlight Thumbnail
            </h6>
          </Link>
        </div>
        <div
          data-aos-delay="4"
          className="col-lg-4 col-md-6 col-sm-6 col-xs-12"
        >
          <Link to="/Valorant1#projectDetails">
            <motion.img
              whileHover={{
                scale: 1.1,
                transition: { duration: 0.4, ease: [0.6, 0.01, -0.05, 0.9] },
              }}
              src={Valorant1}
              style={{
                width: "90%",
                borderRadius: "4px",
                margin: "1rem",
                cursor: "pointer",
              }}
              alt=""
            />{" "}
            <h6 className="text-center proj--name">Valorant Thumbnail</h6>
          </Link>
        </div>
        <div
          data-aos-delay="4.3"
          className="col-lg-4 col-md-6 col-sm-6 col-xs-12"
        >
          <Link to="/Valorant2#projectDetails">
            <motion.img
              whileHover={{
                scale: 1.1,
                transition: { duration: 0.4, ease: [0.6, 0.01, -0.05, 0.9] },
              }}
              src={Valorant2}
              style={{
                width: "90%",
                borderRadius: "4px",
                margin: "1rem",
                cursor: "pointer",
              }}
              alt=""
            />{" "}
            <h6 className="text-center proj--name">Valorant Thumbnail</h6>
          </Link>
        </div>
      </div>
    </AnimatePresence>
  );
}
